<template>
    <landlords-current
        v-slot="{
            data: landlord
        }"
    >
        <job-sheets-contacts-update
            :params="{
                job_sheet: jobSheet.uuid,
                job_sheet_contact: contact.uuid
            }"
            v-slot="{
                sid,
                is_loading: is_saving,
                error,
                update,
            }"
            @success="onSuccess"
        >
            <div
                v-if="!landlord"
                class="w-6 h-6"
            >
                <button
                    type="button"
                    class="w-full h-full focus:outline-none"
                    @click.prevent="open"
                >
                    <base-svg
                        name="icon-notification"
                        class="w-full h-full"
                    />
                </button>

                <error-modal
                    v-if="error && $error.is(error, { exclude: [422] })"
                    :error="error"
                    @close="forget"
                />

                <modal-success
                    v-else-if="show_updated_modal"
                    :is-open="show_updated_modal"
                    @close="closeAll();"
                >
                    <template slot="heading">Notification settings updated!</template>

                    <p>We've updated your notification settings.</p>

                    <div
                        slot="footer"
                        slot-scope="{ close }"
                        class="flex flex-col md:flex-row-reverse"
                    >
                        <button
                            type="button"
                            @click.prevent="close"
                            class="text-center btn"
                        >
                            Close
                        </button>
                    </div>
                </modal-success>

                <modal-blue
                    v-else-if="show_edit_modal"
                    :is-open="show_edit_modal"
                    @close="show_edit_modal = false"
                    v-slot="{ close }"
                >
                    <recaptcha-form
                        v-model="form.recaptcha"
                        @submit="update(form)"
                    >
                        <div class="px-4 pt-6 border-b sm:px-6">
                            <h6 class="mb-3 text-lg font-normal font-semibold text-center">
                                Notification settings
                            </h6>

                            <p class="mb-6">
                                If you would rather we send notifications of updates to this job sheet to a different place,
                                let us know:
                            </p>

                            <validator-alert :sid="sid" />

                            <grid-layout>
                                <grid-layout-item>
                                    <form-item
                                        :sid="sid"
                                        name="email"
                                    >
                                        <template slot="label">Email</template>

                                        <input-text
                                            v-model="form.email"
                                            :sid="sid"
                                            :disabled="is_saving"
                                            name="email"
                                            type="email"
                                        />
                                    </form-item>
                                </grid-layout-item>

                                <grid-layout-item>
                                    <form-item
                                        :sid="sid"
                                        name="telephone"
                                    >
                                        <template slot="label">Telephone</template>

                                        <input-telephone
                                            v-model="form.telephone"
                                            :sid="sid"
                                            :disabled="is_saving"
                                            name="telephone"
                                        />
                                    </form-item>
                                </grid-layout-item>
                            </grid-layout>
                        </div>

                        <base-form-footer
                            :show-required="false"
                            class="rounded-b"
                        >
                            <div class="md:flex md:flex-row-reverse">
                                <base-button
                                    :is-loading="is_saving"
                                    class="w-full mb-2 md:w-auto btn-blue"
                                >
                                    Update
                                </base-button>

                                <button
                                    @click.prevent="close"
                                    class="w-full btn md:w-auto"
                                >
                                    Close
                                </button>
                            </div>
                        </base-form-footer>
                    </recaptcha-form>
                </modal-blue>
            </div>
        </job-sheets-contacts-update>
    </landlords-current>
</template>

<script>
    import _ from 'lodash'
    import JobSheetsContactsUpdate from '../../../../components/job-sheets-contacts-update'
    import LandlordsCurrent from '../../../../components/landlords-current'

    export default {
        components: {
            JobSheetsContactsUpdate,
            LandlordsCurrent
        },
        props: {
            jobSheet: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_edit_modal: false,
                show_updated_modal: false,
                form: {
                    recaptcha: '',
                    email: '',
                    telephone: null
                }
            }
        },
        computed: {
            contact () {
                return _.get(this.jobSheet, 'contacts.data.0')
            }
        },
        created () {
            this.reset()
        },
        methods: {
            open () {
                setTimeout(() => {
                    this.show_edit_modal = true
                }, 0)
            },
            onSuccess () {
                setTimeout(() => {
                    this.show_edit_modal = false

                    setTimeout(() => {
                        this.show_updated_modal = true
                    }, 0)
                }, 0)
            },
            closeAll () {
                this.show_edit_modal = false
                this.show_updated_modal = false
            },
            reset () {
                this.form.email = _.get(this.contact, 'email')
                this.form.telephone = _.get(this.contact, 'telephone_number')
                    ? _.pick(this.contact.telephone_number, ['prefix', 'suffix'])
                    : null
            }
        }
    }
</script>
